export default "__VITE_ASSET___ZiCgAlD__"